import { useState, useCallback } from 'react';

export const useSearchLogic = (initialCategory = 'all') => {
	const [selectedCategory, setSelectedCategory] = useState(initialCategory);
	const [selectedPeriod, setSelectedPeriod] = useState('all');
	const [searchTerm, setSearchTerm] = useState('');
	const [page, setPage] = useState(1);

	const handleFilterChange = useCallback(
		(setter: (val: any) => void) => (value: any) => {
			setter(value);
			setPage(1);
		},
		[]
	);

	const resetFilters = useCallback(() => {
		setSelectedCategory(initialCategory);
		setSelectedPeriod('all');
		setSearchTerm('');
		setPage(1);
	}, [initialCategory]);

	return {
		searchState: {
			selectedCategory,
			selectedPeriod,
			searchTerm,
			page
		},
		searchHandlers: {
			onCategoryChange: handleFilterChange(setSelectedCategory),
			onPeriodChange: handleFilterChange(setSelectedPeriod),
			onSearchChange: handleFilterChange(setSearchTerm),
			onSearchSubmit: handleFilterChange(setSearchTerm),
			handlePageChange: setPage
		},
		resetFilters
	};
};
